import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { TaxDotComDocsSvcLogRepository } from '../taxDotComDocsSvcLog.repository';

export class TaxDotComDocsSvcLogListAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _taxDotComDocsSvcLogRepository: TaxDotComDocsSvcLogRepository
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.TaxDotComDocsSvcSummaryLogPropertyEnum>[] = [
        { name: 'taxDotComDocsSvcSummaryLogId', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.TaxDotComDocsSvcSummaryLogId },
        { name: 'operationType', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.OperationType },
        { name: 'startTime', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.StartTime },
        { name: 'endTime', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.EndTime },
        { name: 'tenantId', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.TenantId },
        { name: 'fileName', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.FileName },
        { name: 'requestPayloadJson', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.RequestPayloadJson },
        { name: 'responsePayloadJson', value: Core.TaxDotComDocsSvcSummaryLogPropertyEnum.ResponsePayloadJson }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.TaxDotComDocsSvcSummaryLogSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap)
        };

        const result = await lastValueFrom(this._taxDotComDocsSvcLogRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
